import React from 'react';
import { ConfirmActors } from './confirm-actors';
const ReadonlyActors = _ref => {
  let {
    onButtonClick,
    section
  } = _ref;
  const {
    beneficialOwners,
    boardChairman,
    boardMembers,
    ceo
  } = section;
  const informationText = 'Det kan oppstå forsinkelser i oppdateringen av dataene. Vennligst oppdater de offentlige registrene hvis du ikke har gjort det ennå. Om du ser at denne informasjonen ikke stemmer må du kontakte banken.';
  const renderReadOnlyBeneficialOwnerReasons = beneficialOwner => {
    return beneficialOwner.beneficialOwnerReasons.map(reason => reason.text).join(', ');
  };
  const renderReadOnlyBeneficialOwners = beneficialOwners => {
    return beneficialOwners.map(beneficialOwner => {
      return /*#__PURE__*/React.createElement("div", {
        className: "beneficial-owners-section",
        key: beneficialOwner.publicId.value
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-question-readonly"
      }, "Fornavn"), /*#__PURE__*/React.createElement("span", {
        className: "form-question-readonly-answer"
      }, beneficialOwner.firstName), /*#__PURE__*/React.createElement("div", {
        className: "form-question-readonly"
      }, "Etternavn"), /*#__PURE__*/React.createElement("span", {
        className: "form-question-readonly-answer"
      }, beneficialOwner.lastName), /*#__PURE__*/React.createElement("div", {
        className: "form-question-readonly"
      }, "F\xF8dselsnummer / D-nummer"), /*#__PURE__*/React.createElement("span", {
        className: "form-question-readonly-answer"
      }, beneficialOwner.publicId.value), /*#__PURE__*/React.createElement("div", {
        className: "form-question-readonly"
      }, "Eierandel"), /*#__PURE__*/React.createElement("span", {
        className: "form-question-readonly-answer"
      }, beneficialOwner.ownershipPercentage.toString()), beneficialOwner.beneficialOwnerReasons.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "form-question-readonly"
      }, "Typer av bestemmende kontroll"), /*#__PURE__*/React.createElement("span", {
        className: "form-question-readonly-answer"
      }, renderReadOnlyBeneficialOwnerReasons(beneficialOwner))));
    });
  };
  const renderReadOnlyActor = boardMember => {
    return boardMember && /*#__PURE__*/React.createElement("div", {
      className: "board-member-section",
      key: boardMember.publicId.value
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-question-readonly"
    }, "Fornavn"), /*#__PURE__*/React.createElement("span", {
      className: "form-question-readonly-answer"
    }, boardMember.firstName), /*#__PURE__*/React.createElement("div", {
      className: "form-question-readonly"
    }, "Etternavn"), /*#__PURE__*/React.createElement("span", {
      className: "form-question-readonly-answer"
    }, boardMember.lastName), /*#__PURE__*/React.createElement("div", {
      className: "form-question-readonly"
    }, "F\xF8dselsnummer / D-nummer"), /*#__PURE__*/React.createElement("span", {
      className: "form-question-readonly-answer"
    }, boardMember.publicId.value));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "info-text"
  }, informationText), /*#__PURE__*/React.createElement("h2", {
    className: "header-title-readonly"
  }, "Daglig leder"), renderReadOnlyActor(ceo), /*#__PURE__*/React.createElement("h2", {
    className: "header-title-readonly"
  }, "Styreleder"), renderReadOnlyActor(boardChairman), /*#__PURE__*/React.createElement("h2", {
    className: "header-title-readonly"
  }, "Styremedlemmer"), boardMembers.map(boardMember => renderReadOnlyActor(boardMember)), /*#__PURE__*/React.createElement("h2", {
    className: "header-title-readonly"
  }, "Reelle rettighetshavere"), renderReadOnlyBeneficialOwners(beneficialOwners), /*#__PURE__*/React.createElement(ConfirmActors, {
    actors: {
      typeInfo: 'READ_ONLY'
    },
    onConfirmed: onButtonClick
  }));
};
export default ReadonlyActors;